var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39961 10.4001L4.96611 8.00013L6.79933 9.71439L10.8324 5.94302M8.08853 5.6001H11.1996V8.50929M3.19961 14.4001C2.31595 14.4001 1.59961 13.6838 1.59961 12.8001V3.2001C1.59961 2.31644 2.31595 1.6001 3.19961 1.6001H12.7996C13.6833 1.6001 14.3996 2.31644 14.3996 3.2001V12.8001C14.3996 13.6838 13.6833 14.4001 12.7996 14.4001H3.19961Z",
    stroke: "#4A5467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnalytics);
export default __webpack_public_path__ + "static/media/ic-analytics.a839fee06433227ffea57c5bba2acc29.svg";
export { ForwardRef as ReactComponent };